// extracted by mini-css-extract-plugin
export default {"toggle_btn_active":"style_toggle_btn_active__OhJ+V","toggle_btn_inactive":"style_toggle_btn_inactive__k2eGy"};